import React, { FC } from 'react'

//* styles
import {
  LeadershipModalContent,
  LeadershipModalFooter,
  LeadershipModalHolder,
  LeadershipModalImage,
  LinkItem,
  RowContent,
} from './style'

//* utils
import { findTarget } from '../../../../../utils/microcopy.utils'
import { renderRichText } from '../../../../../utils/richTextHandler.utils'

//* components
import { BlogTwitter } from '../../../../../constants/svg'
import Modal from '../../../../global/modal'
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'

type Props = {
  open: boolean
  onClose: () => void
  data: any
  contentType?: string
  useCase?: string
}

const LeadershipModal: FC<Props> = ({ open, onClose, data, contentType = '' }) => {
  if (!data) return null
  const {
    fullName,
    role,
    miniBio,
    twitterProfile,
    linkedInProfile,
    image,
    microcopy,
    topicItemListUseCase,
  } = data
  const handleClose = () => onClose()

  return (
    <Modal
      modalTitle="Standard Modal"
      modalDescription="UiPath Leadership Modal"
      innerClasses="LeadershipBioModal"
      handleClose={handleClose}
      open={open}
      dotted={true}
      contentType={contentType}>
      <LeadershipModalHolder
        data-cy="LeadershipModalHolder"
        $contentType={contentType}
        className={topicItemListUseCase === 'Events' ? 'PageEventSpeaker' : ''}>
        {image && (
          <LeadershipModalImage data-cy="LeadershipModalImage">
            <WrapperImage
              src={image}
              className={topicItemListUseCase === 'Events' ? 'PageEventSpeaker__Image' : ''}
            />
          </LeadershipModalImage>
        )}

        <LeadershipModalContent>
          {fullName && (
            <RowContent className="Content-FullName">
              <Typography type="header3">{fullName}</Typography>
            </RowContent>
          )}

          {role && (
            <RowContent className="Content-Role">
              <Typography type="bodyXS" className="font__inter">
                {role}
              </Typography>
            </RowContent>
          )}

          {miniBio && (
            <RowContent className="Content-MiniBio">{renderRichText(miniBio)}</RowContent>
          )}

          <LeadershipModalFooter>
            {twitterProfile && microcopy?.values && (
              <a className="Content-LinkProfile" href={twitterProfile} target="_blank">
                <LinkItem className="BioPost__SocialMedia-Item">
                  <BlogTwitter />
                </LinkItem>

                <Typography className="BioCardFooter-ProfileType font__inter" type="bodyXS">
                  {findTarget(`Twitter.text`, microcopy.values, false) || 'Twitter'}
                </Typography>
              </a>
            )}

            {linkedInProfile && microcopy?.values && (
              <a className="Content-LinkProfile" href={linkedInProfile} target="_blank">
                <LinkItem className="BioCardFooter-LinkedInProfile" />

                <Typography className="BioCardFooter-ProfileType font__inter" type="bodyXS">
                  {findTarget(`Linkedin.text`, microcopy.values, false) || 'LinkedIn'}
                </Typography>
              </a>
            )}
          </LeadershipModalFooter>
        </LeadershipModalContent>
      </LeadershipModalHolder>
    </Modal>
  )
}

export default LeadershipModal
